<link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">
<!-- Web view -->
<div class="web-view" fxHide.xs fxHide.sm fxHide.lt-md fxFlex.md>

  <div class="navbar-div">
    <app-web-navbar></app-web-navbar>
  </div>

  <div class="main-div" fxLayout="row wrap" fxLayoutAlign="center center">
    <h1 class="heading">Join Artist & Audience Meetups</h1>
    <h4 class="paragraph">

      We welcome you to RSVP and then make sure to attend any of the Artist & Audience Meetup
      below. Make sure to go to the MOVIE/EVENT PAGE and watch the
      featured Showcase Movie or attend the Spotlight Event prior to the Meetup—as
      that is the fun and center point of the Meetup's conversations and sharing.
      MAKE SURE TO MARK YOUR CALENDAR (AFTER YOU RSVP) AND RETURN TO
      THIS PAGE TO JOIN THE MEETUPS AT THE APPOINTED DATE/TIME. TIMES
      BELOW HAVE BEEN ADJUSTED TO YOUR TIMEZONE! You will also receive RSVP confirmation in your My Tickets page.
      When a party is filled, you will
      not be able to RSVP.

    </h4>

    <div class="web-table-container">
      <table style="margin-right: auto;margin-left: auto;">
        <thead>
          <tr>
            <th fxLayout="row" fxLayoutAlign="space-between center" colspan="2">
              <div class="web-table-header" fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="40px">
                <div>
                  <span><mat-icon aria-hidden="false" aria-label="Filter icon">filter_alt</mat-icon>&nbsp;Sort By :</span>
                </div>
                <div>
                  <span (click)="sortbyname()"><mat-icon aria-hidden="false" aria-label="CC icon">closed_caption_off</mat-icon>&nbsp; Title</span>
                </div>
                <div>
                  <span (click)="sortbydate()"><mat-icon aria-hidden="false" aria-label="Calendar icon">event</mat-icon>&nbsp;Date</span>
                </div>
              </div>
            </th>

            <th>
              <input class="form-control" id="web-searchbar" type="text" placeholder="search here.." name="searchBox"
                [(ngModel)]="searchBox" (ngModelChange)="search()">
            </th>
          </tr>
        </thead>
        <tbody>
          <h1 *ngIf="filterPartyList.length == 0 " class="msg">No Artist & Audience Meetups hosted yet.
             <a routerLink="/cinejoy/screening-parties/host">Click here</a> and be the first to host a Artist & Audience Meetup!</h1>
          <tr *ngFor="let Party of filterPartyList |sort :rev:sorted:sortByName | sort : reverse:sorted:sortByDate"
            class="web-table-content">
            <td class="web-image">
              <img class="img-fluid" src="{{Party.imageUrl}}" alt="movie-img">
            </td>
            <td class="web-info">
              <p class="web-name">{{Party.movieName | uppercase}}</p>
              <p class="web-screening">Artist & Audience Meetup</p>
              <p class="web-host">Hosted by {{Party.firstName}}&nbsp;{{Party.lastName}}</p>

              <p *ngIf="Party.showPartyFullMessage">Oops. You can't join the meetup as the Artist & Audience Meetup
                is full.</p>
              <p *ngIf="Party.capacityFull">This Artist & Audience Meetup is full.</p>
              <p class="web-description">Description :</p>
              <p *ngIf="Party.description && !Party.isReadMore" style="color: #fff;font-size: 16px;">
                {{Party.description | slice:0:20}}</p>
              <div class="readmore" *ngIf="Party.description && Party.isReadMore">
                {{Party.description}} </div>
              <button class="web-btn1" style="background-color: black;" *ngIf="Party.description && Party.description.length > 20"
                (click)="readMoreOrLess(Party.id,Party.isReadMore ? false:true)"
                id="myBtn">{{Party.isReadMore ?'View Less': 'Read More'}}</button>

              <p class="web-date" *ngIf="Party.description === '' || !Party.description">-</p>
              <p class="web-date">{{Party.meetingDateTime |date:'EEEE, MMM dd, yyyy h:mm:ss a'}} {{userTimezoneNameSP(Party.meetingDateTime)}}</p>




              <p class="buttons">
                <button class="web-btn1" type="button" data-bs-toggle="modal" data-bs-target="#myModal"
                  data-backdrop="false"
                  [ngStyle]="{'background-color':Party.capacityFull || Party.isUserRegistered ? 'darkslategrey': 'black' }"
                  [disabled]="Party.isUserRegistered" (click)="onRsvp(Party.id)">RSVP</button>&nbsp;&nbsp;

             
                <button class="web-btn1" (click)='gotoJoin(Party.meetingLink)'[disabled]='!Party.enableJoinButton'
                [ngStyle]="{'background-color':Party.enableJoinButton ? 'black': 'darkslategrey' }">
                  JOIN </button>&nbsp;&nbsp;

                <button class="web-btn1" style="background-color: black;"><a class="web-btn1"style="background-color: black;text-decoration-line: none;" (click)="navigateShowcase(Party)"
                 >MOVIE/EVENT</a></button>
                 <button *ngIf="(Party.isUserHost && Party.edits<2) || Party.isUserAdmin" class="web-btn1"
                 (click)='editParty(Party)' style="background-color: black;">EDIT</button>

                 <button *ngIf="!Party.bookmarked" 
                    style="background-color: #de1b36;text-decoration-line: none; border: none;" 
                    (click)="bookmarkEvent(Party.id, true)">
                    <img src="../../../../../assets/images/LineupPass.png" alt="Bookmark Image" width="40px" height="37.5px" />
                </button>
                <button *ngIf="Party.bookmarked" 
                    style="background-color: #de1b36;text-decoration-line: none; border: none;"
                    (click)="alreadyBookmarkEvent(true)">
                    <img src="../../../../../assets/images/LineupBookmarked.png" alt="Bookmark Image" width="40px" height="37.5px" />
                </button>

              </p>
            
            </td>
          </tr>

        </tbody>
      </table>
    </div>
  </div>

  <div class="footer-div">
    <app-cinejoy-footer></app-cinejoy-footer>
  </div>
</div>


<!-- Mobile view -->


<div class="mobile-view" fxHide.lg fxHide.md fxHide.lt fxFlex.lt-md fxShow.xs fxHide.gt-lg>

  <div class="mobile-navbar">
    <app-sidebar></app-sidebar>
  </div>

  <div class="navbar-div">
    <app-web-navbar></app-web-navbar>
  </div>


  <div class="main-div-mob" fxLayout="row wrap" fxLayoutAlign="center center">
    <h1 class="heading-mob">Join Artist & Audience Meetups</h1>
    <h4 class="paragraph-mob">

      We welcome you to RSVP and then make sure to attend any of the Artist & Audience Meetup below.
      Make sure to go to the MOVIE/EVENT PAGE and watch the
      featured Showcase Movie or attend the Spotlight Event prior to the Meetup—as
      that is the fun and center point of the Meetup's conversations and sharing.
      MAKE SURE TO MARK YOUR CALENDAR (AFTER YOU RSVP) AND RETURN TO
      THIS PAGE TO JOIN THE MEETUP AT THE APPOINTED DATE/TIME. TIMES
      BELOW HAVE BEEN ADJUSTED TO YOUR TIMEZONE! You will also receive RSVP confirmation in your My
      Tickets page. When a meetup is filled, you will
      not be able to RSVP.

    </h4>


    <div class="row" id="mob-border">
      <table>
        <tr>
          <th fxLayout="row" fxLayoutAlign="space-between" >
            <div class="mob-table-header" fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="35px">
              <div>
                <mat-icon aria-hidden="false" aria-label="Example home icon">filter_alt</mat-icon>&nbsp;<span class="icons">Sort By:</span>
              </div>
              <div>

                <mat-icon aria-hidden="false" aria-label="CC icon">closed_caption_off</mat-icon>&nbsp; <span class="icons"
                  (click)="sortbyname()">Title</span>
              </div>
              <div>
                <mat-icon aria-hidden="false" aria-label="Calendar icon">event</mat-icon>&nbsp;<span class="icons"
                  (click)="sortbydate()">Date</span>
              </div>
            </div>
          </th>
          <th></th>

        </tr>
      </table>
    </div>
    <br><br>
    <div id="searchbox">

      <input class="form-control" id="web-searchbar-mob" type="text" placeholder="search here.." name="FirstName"
        [(ngModel)]="searchBox" (ngModelChange)="search()">

    </div>
    <h1 *ngIf="filterPartyList.length == 0 " class="msg">No Artist & Audience Meetups hosted yet.
      <a routerLink="/cinejoy/screening-parties/host">Click here</a> and be the first to host a Artist & Audience Meetup!</h1>
    <div class="row"
      *ngFor="let Party of filterPartyList  |sort :rev:sorted:sortByName | sort : reverse:sorted:sortByDate"
      class="web-table-content-mob">
      <div class="row">
        <img class="img-fluid-mob" src="{{Party.imageUrl}}" alt="">
      </div>
      <div class="row" id="partyinfo">
        <p class="web-name" id="mob-name">{{Party.movieName | uppercase}}</p>
        <p class="web-screening">Artist & Audience Meetup</p>
        <p class="web-host">Hosted by {{Party.firstName}}&nbsp;{{Party.lastName}}</p>
        <p *ngIf="Party.showPartyFullMessage">Oops. You can't join the meetup as the Artist & Audience Meetup
          is full.</p>
        <p *ngIf="Party.capacityFull">This Artist & Audience Meetup is full.</p>

        <p class="web-description">Description :</p>
        <p *ngIf="Party.description && !Party.isReadMore" class="description-mob">
          {{Party.description | slice:0:20}}</p>
        <div class="readmore-mob" *ngIf="Party.isReadMore" style="color: #fff;font-size: 16px;">
          {{Party.description}} </div>
          <button class="mob-btn1" style="background-color: black;"*ngIf="Party.description && Party.description.length > 20"
          (click)="readMoreOrLess(Party.id,Party.isReadMore ? false:true)" id="myBtn">{{Party.isReadMore
                    ?'View Less': 'Read More'}}</button>

        <p class="web-date" *ngIf="Party.description === '' || !Party.description">-</p>
        <p class="web-date">{{Party.meetingDateTime | date:'EEEE, MMM dd, yyyy h:mm:ss a'}} {{userTimezoneNameSP(Party.meetingDateTime)}}</p>


        <p class="buttons">
          <button class="web-btn1-mob" type="button" data-bs-toggle="modal" data-bs-target="#myModal"
            data-backdrop="false"
            [ngStyle]="{'background-color':Party.capacityFull || Party.isUserRegistered ? 'darkslategrey': 'black' }"
            [disabled]="Party.isUserRegistered" (click)="onRsvp(Party.id)">RSVP</button>&nbsp;&nbsp;


          <button class="web-btn1-mob" (click)='gotoJoin(Party.meetingLink)' [disabled]='!Party.enableJoinButton'
          [ngStyle]="{'background-color':Party.enableJoinButton ? 'black': 'darkslategrey' }">
            JOIN </button>&nbsp;&nbsp;
           
            <button class="web-btn1-mob" style="background-color: black;"><a class="web-btn1-mob"style="background-color: black;text-decoration-line: none;" (click)="navigateShowcase(Party)">
              MOVIE/EVENT</a></button>
              <button *ngIf="(Party.isUserHost && Party.edits<2) || Party.isUserAdmin" class="web-btn1-mob"
            (click)='editParty(Party)' style="background-color: black;">EDIT</button>

          <button *ngIf="!Party.bookmarked" 
            class="web-btn1-mob"
            style="background-color: black;text-decoration-line: none;" 
            (click)="bookmarkEvent(Party.id, true)">
            <img src="../../../../../assets/images/LineupPass.png" alt="Bookmark Image" width="40px" height="37.5px" />
          </button>

          <button *ngIf="Party.bookmarked" 
              class="web-btn1-mob" 
              style="background-color: black;text-decoration-line: none;"
              (click)="alreadyBookmarkEvent(true)">
              <img src="../../../../../assets/images/LineupBookmarked.png" alt="Bookmark Image" width="40px" height="37.5px" />
          </button>

      </div>
    </div>
  </div>

  <div class="footer-div">
    <app-cinejoy-mobile-footer></app-cinejoy-mobile-footer>
  </div>
</div>

<!-- The Modal -->
<div class="modal" id="myModal">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content" style="background-color: #fff !important;">


      <div class="modal-header">

        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body">
        <p class="rsvptxt">Thanks for RSVP'ing. Please return to this page to Join
          the meetup at the designated Day/Time</p>
      </div>
    </div>
  </div>
</div>
